export const useCategory = async(
    category: MaybeRefOrGetter<Readonly<string>>,
    param: MaybeRefOrGetter<Readonly<string|string[]>>,
    pageRef: Ref<number>,
    label: MaybeRefOrGetter<Readonly<string>>|null = null,
) => {
    const route = useRoute();
    const { options } = await useCategoryFilter(
        category,
        label
    );

    const selected = ref(getArray(route?.query?.[toValue(param)] ?? []));

    syncRoute(selected, param, { page: 1 });
    watch(selected, () => {
        pageRef.value = 1;
    });

    return {
        options,
        selected
    };
};
